import { render, staticRenderFns } from "./mo-loading-page.html?vue&type=template&id=0b068d26&external"
import script from "./mo-loading-page.ts?vue&type=script&lang=ts&external"
export * from "./mo-loading-page.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b068d26')) {
      api.createRecord('0b068d26', component.options)
    } else {
      api.reload('0b068d26', component.options)
    }
    module.hot.accept("./mo-loading-page.html?vue&type=template&id=0b068d26&external", function () {
      api.rerender('0b068d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-loading-page/mo-loading-page.vue"
export default component.exports